import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { useLayout } from '@/store/layoutStore';

import Header from './Header';
import Sidebar from './Sidebar';
import styles from './Layout.module.css';

/**
 * Layout Component
 * Main layout wrapper for authenticated pages
 */
const Layout: FC = () => {
  const { menuOpen, menuMode } = useLayout();

  return (
    <div className={`${styles.layout} ${styles[menuMode]}`}>
      <Header />
      
      {menuMode === 'vertical' && (
        <Sidebar isOpen={menuOpen} />
      )}
      
      <main 
        className={`${styles.main} ${menuOpen && menuMode === 'vertical' ? styles.mainWithSidebar : ''}`}
      >
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;